export const environment = {
  production: true,
  SF_URL: 'https://startfire.cl/',
  SF_URL_V2: 'https://startfire.cl/',
  API_URL: 'https://api.startfire.cl/public/',
  COTIZACIONES_URL: 'https://cotizaciones.startfire.cl/',
  ORDEN_DE_COMPRAS_URL: 'https://ordendecompra.startfire.cl/',
  PRODUCTOS_IMPORTACION_URL: 'https://admin-v2.startfire.cl/dashboard/productos-de-importacion',
  ADMIN_URL: 'https://admin-v2.startfire.cl/',
  SF_API_V2: 'https://api.v2.startfire.cl',
};


// WEBPACK FOOTER //
// /app/src/environments/environment.ts